module.exports = __webpack_public_path__ + "static/media/landelijk.887c945f.jpg";